<template lang="pug">
  #footer
    p(v-if="!isDemoUser") {{ $t('footer.copyright', { year: currentYear }) }}
</template>

<script>
  import { mapState } from 'vuex'
  import { isEmpty } from 'lodash'

  export default {
    data() {
      return {
        usersWithoutCopyright: [
          'demo_user2@rentassessment.com'
        ]
      }
    },

    computed: {
      ...mapState(['currentUser']),

      isDemoUser() {
        if (isEmpty(this.currentUser)) {
          return false          
        } else {
          return this.usersWithoutCopyright.includes(this.currentUser.email)
        }
      },

      currentYear() {
        const currentDate = new Date
        return currentDate.getFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
  #footer {
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    margin-top: 10px;
  }
</style>
